import React from "react";

import "./Plantillas.css";

const Plantillas = (props) => {
  return <a className="link-list-item-url" href="https://drive.google.com/drive/folders/1m3W2qBEKyN-N4OXt16v89w4U6PwA2Mcs">Drive Plantillas de Documentos</a>;
};

export default Plantillas;